import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../../service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthRedirectGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.isAuthenticated()) {
      // Parse hash part of URL for hash routing (primary method)
      let redirectParam = null;
      try {
        const hash = window.location.hash;
        if (hash.includes('?')) {
          const queryString = hash.split('?')[1];
          const urlParams = new URLSearchParams(queryString);
          redirectParam = urlParams.get('redirect');
        }
      } catch (e) {}

      // Fallback to router parsing
      if (!redirectParam) {
        try {
          const urlTree = this.router.parseUrl(this.router.url);
          redirectParam = urlTree.queryParams['redirect'];
        } catch (e) {}
      }

      if (redirectParam) {
        const decodedRedirectUrl = decodeURIComponent(redirectParam);
        this.router.navigateByUrl(decodedRedirectUrl);
        return false;
      }

      // Default to dashboard
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}